export default "__VITE_ASSET__DJFUaPrD__"